"use strict";

exports.__esModule = true;
var ramda_1 = require("ramda");
var utils_1 = require("../utils");
var rbac_1 = require("./rbac");
var generateAppConfig = function (user) {
  if (utils_1.getIsRbacUser(user)) {
    return rbac_1["default"](user);
  }
  var config = {};
  var scopes = user.scopes,
    gates = user.gates,
    roles = user.roles;
  var isOrgAdmin = utils_1.getIsOrgAdmin(scopes);
  var isPlaybooksUser = utils_1.getIsPlaybooksUser(roles);
  // check access to automation application
  config = ramda_1.set(ramda_1.lensProp('hasAutomation'), !!gates.has_automation && (isOrgAdmin || isPlaybooksUser), config);
  return config;
};
exports["default"] = generateAppConfig;